import { ButtonIcon, Tooltip } from "pepsico-ds";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/app";
import { unArchiveChat } from "../../../../../redux/reducers/chatActions/archivedChatsReducer";
import ChatListItem from "../../../ChatListItem/ChatListItem";
import { unwrapResult } from "@reduxjs/toolkit";
import { CloseOutRadioActions } from "../../../../../redux/closeoutslice/closeOutRadioSlice";
import { setIsArchived } from "../../../../../redux/actions/chatActions";
interface ArchieveListItemProps {
  chatId: string;
  sessionName: string;
  updatedDate: string;
}
function ArchieveListItem(props: ArchieveListItemProps) {
  const dispatch = useAppDispatch();
  const { chatId, sessionName, updatedDate } = props;
  const navigate = useNavigate();
  const params = useParams<{ sessionId: string }>();
  const { sessionId: urlSession } = params;
  const isActive = urlSession === chatId;
  const goToChatHandler = () => {
    navigate(`/spend-wise-hub/chat-assistant/${chatId}`);
  };
  const unArchiveHandler = () => {
    dispatch(unArchiveChat(chatId))
      .then(unwrapResult)
      .then(() => {
        dispatch(setIsArchived(false));
        dispatch(
          CloseOutRadioActions.setSnackBarMessage({
            message: "Chat unarchived successfully.",
            severity: "success",
          })
        );
      })
      .catch((error) => {
        dispatch(
          CloseOutRadioActions.setSnackBarMessage({
            message: "Failed unarchive chat.",
            severity: "error",
          })
        );
      });
  };
  const more = (
    <Tooltip text="Unarchive" direction="left">
      <ButtonIcon
        onClick={unArchiveHandler}
        icon="unarchive"
        size="large"
        style={{
          color: "#005CBB",
        }}
      />
    </Tooltip>
  );
  return (
    <>
      <ChatListItem
        chatId={chatId}
        sessionName={sessionName}
        updatedDate={updatedDate}
        isActive={isActive}
        primaryAction={goToChatHandler}
        more={more}
      />
    </>
  );
}

export default ArchieveListItem;
